/**
 * Site Admin Theme Configurations
 *
 * Themes for site-specific admin portals (/{site}/admin/)
 * Each site has its own color scheme
 */

import { AdminThemeConfig } from '@app-types/admin-theme';

/**
 * Medix Site Admin Theme
 * Brighter slate/blue palette – same tone as full admin, less heavy
 */
export const medixAdminTheme: AdminThemeConfig = {
  adminType: 'site',
  siteType: 'medix',
  siteName: 'Medix 管理ポータル',

  adminTheme: {
    name: 'Admin theme',
    displayName: 'Medix Admin',
    colors: {
      primary: '#334155', // Slate-700 – main (lighter than #1a1a2e)
      primaryHover: '#475569', // Slate-600
      primaryDark: '#1e293b', // Slate-800 – footer
      secondary: '#6366f1', // Indigo – buttons, links
      secondaryHover: '#4338ca',
      sidebarBg: '#334155', // Same as primary
      sidebarText: '#f1f5f9', // Slate-100
      menuOpen: 'rgba(0, 0, 0, 0.12)',
      menuHover: 'rgba(255, 255, 255, 0.1)',
      menuActive: 'rgba(99, 102, 241, 0.35)', // Indigo tint – active item
      sectionHeader: '#475569', // Slate-600 – cards/sections
      sectionHeaderText: '#f1f5f9',
    },
    logoPath: '/images/logo.png',
    sidebarWidth: 'w-60',
  },
};

